module.exports = __webpack_public_path__ + "img/Veranza-32-min.234ba932.jpg";